import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const Page = lazy(() =>
  import("@/components/admin/pages/usage").then((module) => ({
    default: module.AdminUsage,
  })),
);

export const Route = createFileRoute("/admin/usage")({
  component: Page,
});
